const API_URL = '/waste-customer-contract'

export const state = () => ({
  waste_customer_contract: {},
})

export const getters = {
  get: state => {
    return state.waste_customer_contract
  },
}

export const mutations = {
  SET_WASTE_CUSTOMER_CONTRACT(state, contract) {
    state.waste_customer_contract = contract
  },
  REMOVE_WASTE_CUSTOMER_CONTRACT(state) {
    state.waste_customer_contract = {}
  },
}

export const actions = {
  async fetch({ commit }, waste_customer_contract_id) {
    let { data: waste_customer_contract } = await useApi(`${API_URL}/${waste_customer_contract_id}`)

    commit('SET_WASTE_CUSTOMER_CONTRACT', waste_customer_contract.value)

    return waste_customer_contract.value
  },
  async update({ commit }, { waste_customer_contract, waste_customer_contract_id }) {
    let { data } = await useApi(`${API_URL}/${waste_customer_contract_id}`, {
      method: 'put',
      body: waste_customer_contract,
    })
    waste_customer_contract = data.value
    commit('SET_WASTE_CUSTOMER_CONTRACT', waste_customer_contract)

    return waste_customer_contract
  },
  async delete({ commit }, waste_customer_contract_id) {
    await useApi(`${API_URL}/${waste_customer_contract_id}`, { method: 'delete' })

    commit('REMOVE_WASTE_CUSTOMER_CONTRACT')
  },
}
